function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgPowerpoint = function SvgPowerpoint(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FF5722"
    },
    d: "M373.334,117.377c-5.891,0-10.667,4.776-10.667,10.667v64c0,5.891,4.776,10.667,10.667,10.667h64 c5.891,0,10.667-4.776,10.667-10.667C448,150.807,414.571,117.377,373.334,117.377z"
  }), React.createElement("path", {
    style: {
      fill: "#FF5722"
    },
    d: "M373.334,224.044c-17.673,0-32-14.327-32-32v-52.245c-40.733,5.794-69.056,43.512-63.262,84.245 c5.794,40.733,43.512,69.056,84.245,63.262c32.812-4.668,58.594-30.45,63.262-63.262H373.334z"
  }), React.createElement("path", {
    style: {
      fill: "#FF5722"
    },
    d: "M294.656,13.014c-2.531-2.056-5.863-2.842-9.045-2.133l-277.333,64 C3.397,76.003-0.047,80.369,0,85.377v362.667c0.002,5.263,3.843,9.739,9.045,10.539l277.333,42.667 c5.823,0.895,11.269-3.099,12.164-8.921c0.082-0.535,0.124-1.076,0.124-1.617V21.377C298.676,18.124,297.199,15.045,294.656,13.014 z"
  }), React.createElement("path", {
    style: {
      fill: "#FF5722"
    },
    d: "M501.334,458.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h202.667V74.71H288c-5.891,0-10.667-4.776-10.667-10.667S282.109,53.377,288,53.377h213.333c5.891,0,10.667,4.776,10.667,10.667 v384C512,453.935,507.225,458.71,501.334,458.71z"
  }), React.createElement("path", {
    style: {
      fill: "#FF5722"
    },
    d: "M437.334,394.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h149.333c5.891,0,10.667,4.776,10.667,10.667C448,389.935,443.225,394.71,437.334,394.71z"
  }), React.createElement("path", {
    style: {
      fill: "#FF5722"
    },
    d: "M437.334,330.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h149.333c5.891,0,10.667,4.776,10.667,10.667C448,325.935,443.225,330.71,437.334,330.71z"
  })), React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M96,352.044c-5.891,0-10.667-4.776-10.667-10.667V170.71c0-5.891,4.776-10.667,10.667-10.667h42.667 c29.455,0,53.333,23.878,53.333,53.333v21.333c0,29.455-23.878,53.333-53.333,53.333h-32v53.333 C106.667,347.268,101.892,352.044,96,352.044z M106.667,266.71h32c17.673,0,32-14.327,32-32v-21.333c0-17.673-14.327-32-32-32h-32 V266.71z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPowerpoint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/powerpoint.0e97c564.svg";
export { ForwardRef as ReactComponent };